// @flow
import React from "react"
import GoogleLogin from "./GoogleLogin"
import FacebookLogin from "./FacebookLogin"
import { SocialLoginWrap } from "./styled"
import { Or } from "componentsStyled/Layout/Spacers"

type Props = {|
  close: Function,
  signup?: boolean,
|}

const SocialLogin = ({ close, signup }: Props) => (
  <React.Fragment>
    <SocialLoginWrap>
      <GoogleLogin close={close} signup={signup} />
      <FacebookLogin close={close} signup={signup} />
    </SocialLoginWrap>
    <Or>or</Or>
  </React.Fragment>
)

export default SocialLogin



// WEBPACK FOOTER //
// ./src/components/SocialLogin/index.js